export const DataGroup = {
  FUND_ZA: 'fund_za',
  ANNUITY: 'annuity',
  ASSET: 'asset'
};
